export default "__VITE_ASSET__DO$kykrx__"